import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // you can add more states for different plugins
    isGoogleSheetPluginActive: false,
    userName:''
};

export const pluginSlice = createSlice({
    name: 'pluginState',
    initialState,
    reducers: {
        setIsGoogleSheetPluginActive: (state, action) => {
            state.isGoogleSheetPluginActive = action.payload;
        },
        setUserName:(state, action)=>{
            state.userName = action.payload;
        }
    },
});


export const { setIsGoogleSheetPluginActive,setUserName } = pluginSlice.actions;

export default pluginSlice.reducer;
